import React, { useRef, useState, useEffect, useCallback } from "react";

import { Field, useFormikContext } from "formik";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import { IoHelpCircle } from "react-icons/io5";

import {
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Image,
  Input,
  Box,
  HStack,
  VStack,
  Button,
  Icon,
  Grid,
  GridItem,
  Checkbox,
  Tooltip,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";

import { IoTrash } from "react-icons/io5";

import { CustomInputWField } from "../../../../components/CustomInputWField";
import { Group } from "../../Group";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { forNames } from "../../../../utils/masks";

import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";
import CargaSelecaoService from "../../../../../main/services/CargaSelecaoService";
import {
  format,
  isAfter,
  isBefore,
  parse,
  isWithinInterval,
  add,
  isValid,
  intervalToDuration,
} from "date-fns";
import { PopoverGenero } from "../../../../components/PopoverGenero";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import Swal from "sweetalert2";

export const Identificacao = ({
  defaultImage,
  setDefaultImage,
  removeu,
  setRemoveu,
  defaultFoto,
  dataMovimentacao,
  dataMovimentacaoFlag,
  idAnexoFoto,
  idAnexo,
  idTipoPendencia,
  scrollToField,
}) => {
  const inputRef = useRef();
  const { setFieldValue, values, errors, setFieldError } = useFormikContext();
  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [dataMenor, setDataMenor] = useState(false);
  const [dataFutura, setDataFutura] = useState(false);
  const [dataFuturaFoto, setDataFuturaFoto] = useState(false);
  const [dataMenorFoto, setDataMenorFoto] = useState(false);
  const [flag, setFlag] = useState(false);
  const [generos, setGeneros] = useState({ options: [], isLoading: false });
  const { houveExtincaoPoderFamiliar, movimentacoesPendente } = useAppContext();
  const [menorIdade, setMenorIdade] = useState();
  const newDateRef = useRef(null);
  const [racasCores, setRacasCores] = useState({
    options: [],
    isLoading: false,
  });
  const [nacionalidades, setNacionalidades] = useState({
    options: [],
    isLoading: false,
  });
  const [estados, setEstados] = useState({ options: [], isLoading: false });
  const [tiposSanguineos, setTiposSanguineos] = useState({
    options: [],
    isLoading: false,
  });
  const isMobile = useBreakpointValue({ base: true, md: false });

  const anexoRef = useRef(null);

  useEffect(() => {
    scrollToField(anexoRef);
  }, [scrollToField]);

  useEffect(() => {
    setIsOpen(false);
  }, [values?.idGenero]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  const handleGetGeneros = useCallback(() => {
    setGeneros((prevState) => ({ ...prevState, isLoading: true }));
    CargaSelecaoService.getGeneros().then((res) => {
      const tempOptions = res.data.map((genero) => {
        return {
          id: genero.id,
          descricao: genero.descricao,
          genero: genero.genero,
          label: (
            <HStack justifyContent="space-between">
              <Text
                color="#1A203D"
                fontWeight={400}
                fontSize={{ base: "12px", md: "14px" }}
              >
                {genero.genero}
              </Text>

              <Tooltip
                label={genero.descricao}
                fontSize="md"
                textAlign={"justify"}
                width="90%"
              >
                <span className="hint-tooltip">
                  <Icon
                    aria-label="Aviso de pendente"
                    color="#6B6C71"
                    as={IoHelpCircle}
                    boxSize="20px"
                  />
                </span>
              </Tooltip>
            </HStack>
          ),
        };
      });
      setGeneros({ options: tempOptions, isLoading: false });
    });
  }, []);

  const handleGetRacasCores = useCallback(() => {
    setRacasCores((prevState) => ({ ...prevState, isLoading: true }));
    CargaSelecaoService.getRacasCores().then((res) => {
      setRacasCores({ options: res.data, isLoading: false });
    });
  }, []);

  const handleGetNacionalidades = useCallback(() => {
    setNacionalidades((prevState) => ({ ...prevState, isLoading: true }));
    DadosGeograficosService.getNacionalidades().then((res) => {
      const tempNacionalidade = res.data.find(
        (pais) =>
          pais.descricaoNacionalidade.toUpperCase() === "BRASIL".toUpperCase(),
      );

      const newData = res.data.map((item) => {
        const { id, descricaoNacionalidade, ...rest } = item;
        return {
          id,
          nacionalidade: descricaoNacionalidade,
          ...rest,
        };
      });

      setNacionalidades({ options: newData, isLoading: false });
      if (tempNacionalidade && !values.nacionalidade) {
        const { id, descricaoNacionalidade, ...rest } = tempNacionalidade;
        const updatedTempNacionalidade = {
          id,
          nacionalidade: descricaoNacionalidade,
          ...rest,
        };
        setFieldValue("nacionalidade", updatedTempNacionalidade);
      }
    });
  }, [setFieldValue, values.nacionalidade]);

  const handleGetEstados = useCallback(() => {
    setEstados((prevState) => ({ ...prevState, isLoading: true }));

    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  }, []);

  const handleGetTiposSanguineos = useCallback(() => {
    setTiposSanguineos((prevState) => ({ ...prevState, isLoading: true }));

    CargaSelecaoService.getTiposSanguineos().then((res) => {
      const newData = res.data.map((item) => {
        const { id, nomeTipoSanguineo, ...rest } = item;
        return {
          id,
          tipoSanguineo: nomeTipoSanguineo,
          ...rest,
        };
      });
      setTiposSanguineos({ options: newData, isLoading: false });
    });
  }, []);

  useEffect(() => {
    if (values.genero && generos.options.length === 0) {
      setGeneros((prevState) => ({ ...prevState, options: [values.genero] }));
      handleGetGeneros();
    }
    if (values.raca && racasCores.options.length === 0) {
      setRacasCores((prevState) => ({ ...prevState, options: [values.raca] }));

      handleGetRacasCores();
    }
    if (values.nacionalidade && nacionalidades.options.length === 0) {
      setNacionalidades((prevState) => ({
        ...prevState,
        options: [values.nacionalidade],
      }));

      handleGetNacionalidades();
    }
    if (values.naturalidade && estados.options.length === 0) {
      setEstados((prevState) => ({
        ...prevState,
        options: [values.naturalidade],
      }));

      handleGetEstados();
    }
    if (values.tipoSanguineo && tiposSanguineos.options.length === 0) {
      setTiposSanguineos((prevState) => ({
        ...prevState,
        options: [values.tipoSanguineo],
      }));

      handleGetTiposSanguineos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values.raca,
    values.tipoSanguineo,
    values.naturalidade,
    values.genero,
    values.nacionalidade,
  ]);

  useEffect(() => {
    const validateDate = () => {
      const { dataNascimento, dataFoto } = values;
      const currentDate = new Date();

      if (dataNascimento && dataMovimentacao) {
        const birthDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
        const dateObject = new Date(dataMovimentacao);
        const novoTimestamp = format(dateObject, "dd/MM/yyyy");

        const movementDate = parse(novoTimestamp, "dd/MM/yyyy", new Date());

        if (isAfter(birthDate, currentDate)) {
          setDataFutura(true);
          setDataMenor(false);
        } else if (
          isBefore(movementDate, birthDate) &&
          !isAfter(movementDate, currentDate)
        ) {
          setDataMenor(true);
          setDataFutura(false);
        } else {
          setDataMenor(false);
          setDataFutura(false);
        }
      }

      if (dataFoto) {
        const movementDate = parse(dataFoto, "dd/MM/yyyy", new Date());
        if (isAfter(movementDate, currentDate)) {
          setDataFuturaFoto(true);
        } else {
          setDataFuturaFoto(false);
        }
      }

      if (dataNascimento && dataFoto) {
        const birthDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
        const movementDate = parse(dataFoto, "dd/MM/yyyy", new Date());

        if (
          isBefore(movementDate, birthDate) &&
          !isAfter(movementDate, currentDate)
        ) {
          setDataMenorFoto(true);
        } else {
          setDataMenorFoto(false);
        }
      }

      if (dataNascimento && dataMovimentacaoFlag?.dataMovimentacao) {
        const nascimento = parse(dataNascimento, "dd/MM/yyyy", new Date());

        if (!isValid(nascimento)) return;

        const movimentacao = new Date(dataMovimentacaoFlag.dataMovimentacao);
        movimentacao.setHours(0, 0, 0, 0);

        const umAnoDepois = add(nascimento, { years: 1 });

        const dentroUmAno = isWithinInterval(movimentacao, {
          start: nascimento,
          end: umAnoDepois,
        });

        if (!dentroUmAno) {
          setFlag(true);
          setFieldError("dataNascimento", "");
        } else {
          setFlag(false);
          setFieldError("dataNascimento", "");
        }
      }

      if (dataNascimento && movimentacoesPendente) {
        const birthDate = parse(dataNascimento, "dd/MM/yyyy", new Date());

        if (isValid(birthDate)) {
          const today = new Date();
          const idade = intervalToDuration({
            start: birthDate,
            end: today,
          })?.years;

          if (idade >= 18) {
            setMenorIdade(false);
            setFieldError("dataNascimento", "");
          } else {
            setMenorIdade(true);
            setFieldError("dataNascimento", "");
          }
        } else {
          setMenorIdade(false);
          setFieldError("dataNascimento", "");
        }
      }
    };

    validateDate();
  }, [
    values,
    values.dataNascimento,
    dataMovimentacao,
    dataMovimentacaoFlag,
    movimentacoesPendente,
    setFieldError,
  ]);

  const fileHandler = (file) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      setFile({
        file: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Group
      title="Identificação"
      border={["3", "4"].includes(idTipoPendencia) ? "3px solid #4299E199" : ""}
      scrollToField={
        ["3", "4"].includes(idTipoPendencia) ? scrollToField : null
      }
    >
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        w="100%"
        mt="20px"
        alignItems="center"
      >
        <Flex
          w={{ base: "100%", lg: "30%" }}
          alignItems="center"
          justifyContent="center"
          ref={
            idAnexo === "1" || ["1", "2"].includes(idTipoPendencia)
              ? anexoRef
              : null
          }
        >
          <VStack
            alignItems="flex-start"
            border={"solid"}
            borderRadius={"3xl"}
            borderColor={
              idAnexo === "1" || ["1", "2"].includes(idTipoPendencia)
                ? "#4299E199"
                : "#CACACA"
            }
            mr={4}
            px={4}
            py={2}
          >
            <Field name="foto">
              {({ field, form }) => (
                <FormControl
                  isInvalid={form.errors.foto && form.touched.foto}
                  id="foto"
                  d="flex"
                  flexDir="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  {defaultImage || file ? (
                    <Image
                      borderRadius="full"
                      boxSize="135px"
                      src={file ? file.file : defaultImage + "?" + Date.now()}
                      alt={file ? file.file.name : "Logomarca"}
                      onError={() => setDefaultImage("")}
                      fit="cover"
                    />
                  ) : (
                    <Box
                      boxSize="135px"
                      bgColor="#C4C4C4"
                      borderRadius="full"
                    />
                  )}
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    textAlign="center"
                    htmlFor="foto"
                    m="0px"
                  >
                    Foto Criança/Adolescente
                  </FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    name="foto"
                    id="foto"
                    backgroundColor="#fff"
                    d="none"
                    ref={inputRef}
                    onChange={(event) => {
                      form.setFieldValue(
                        field.name,
                        event.currentTarget.files[0],
                      );
                      fileHandler(event.currentTarget.files[0]);
                    }}
                  />
                  <HStack alignItems="center" mt="5px">
                    <Button
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={500}
                      fontSize="13px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      onClick={() => inputRef.current.click()}
                    >
                      {`${
                        !idAnexoFoto || !(file || defaultImage)
                          ? "Incluir"
                          : "Atualizar"
                      } Foto`}
                    </Button>
                    {(file || defaultImage) && (
                      <Icon
                        aria-label="Excluir imagem"
                        color="#9EA1AE"
                        as={IoTrash}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => {
                          Swal.fire({
                            title: "Atenção!",
                            text: "Deseja realmente excluir foto da criança/adolescente?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#169499",
                            cancelButtonColor: "#169499",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setFile(null);
                              form.setFieldValue(field.name, null);
                              inputRef.current.value = "";
                              setRemoveu(true);
                              setDefaultImage("");
                              setFieldValue("dataFoto", "");
                            }
                          });
                        }}
                      />
                    )}
                  </HStack>
                  <FormErrorMessage>{form.errors.foto}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <CustomDatepickerWField
              fieldName="dataFoto"
              label={`Data da Foto ${
                values.foto ||
                (defaultImage && defaultFoto) ||
                (removeu && defaultImage)
                  ? "*"
                  : ""
              }`}
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
            />
            {dataMenorFoto && values.dataNascimento && values.dataFoto && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data da foto não pode ser menor que a data de nascimento.
              </Text>
            )}
            {dataFuturaFoto && values.dataFoto && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data informada não pode ser uma data futura!
              </Text>
            )}
          </VStack>
        </Flex>
        <Flex flexDir="column" w="100%">
          <VStack alignItems="flex-start">
            <CustomInputWField
              fieldName="nome"
              label={`Nome ${
                !values.nomeSocial || values.nomeSocial.trim() === "" ? "*" : ""
              } `}
              placeholder="Informe o Nome"
              onChange={(e) => setFieldValue("nome", forNames(e.target.value))}
              isDisabled={
                (values.nomeNaoInformado &&
                  values?.nomeNaoInformado.length > 0) ||
                values.nomeNaoInformado === true
              }
            />
            <Flex gap={4}>
              <Field name="nomeFicticio">
                {({ field, form }) => (
                  <FormControl id="nomeFicticio" width="max-content">
                    <Checkbox
                      {...field}
                      isChecked={
                        values?.nomeFicticio === true
                          ? true
                          : values?.nomeFicticio === false
                            ? false
                            : values.nomeFicticio?.includes("Possui")
                              ? true
                              : false
                      }
                      name="nomeFicticio"
                      id="nomeFicticio"
                      whiteSpace="nowrap"
                      onChange={(e) => {
                        const newValue = e.target.checked ? ["Possui"] : [];
                        form.setFieldValue("nomeFicticio", newValue);

                        if (newValue.length > 0) {
                          form.setFieldValue("nomeNaoInformado", []);
                          form.setFieldValue("nomeSocial", "");
                          if (values.nomeNaoInformado.length > 0) {
                            form.setFieldValue("nome", "");
                          }
                        }
                      }}
                    >
                      Nome Fictício
                    </Checkbox>
                    <FormErrorMessage>
                      {form.errors.nomeFicticio}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="nomeNaoInformado">
                {({ field, form }) => (
                  <FormControl id="nomeNaoInformado" width="max-content">
                    <Checkbox
                      {...field}
                      value="Possui"
                      name="nomeNaoInformado"
                      id="nomeNaoInformado"
                      whiteSpace="nowrap"
                      isChecked={
                        values?.nomeNaoInformado === true
                          ? true
                          : values?.nomeNaoInformado === false
                            ? false
                            : values?.nomeNaoInformado?.includes("Possui")
                              ? true
                              : false
                      }
                      onChange={(e) => {
                        const newValue = e.target.checked ? ["Possui"] : [];
                        form.setFieldValue("nomeNaoInformado", newValue);
                        if (newValue.length > 0) {
                          form.setFieldValue("nome", "Não Informado");
                          form.setFieldValue("nomeFicticio", []);
                        } else {
                          form.setFieldValue("nome", "");
                        }
                      }}
                    >
                      {`Não Informado${
                        (!form.values.nome || form.values.nome.trim() === "") &&
                        form.values.nomeSocial &&
                        values.nomeSocial.trim() !== ""
                          ? "*"
                          : ""
                      }`}
                    </Checkbox>
                    <Text color="red" opacity={0.8} fontSize="12px">
                      {form.errors.nomeNaoInformado}
                    </Text>
                  </FormControl>
                )}
              </Field>
            </Flex>
          </VStack>
          <CustomInputWField
            fieldName="nomeSocial"
            label={`Nome Social ${
              values?.nomeNaoInformado?.length > 0 ? "*" : ""
            }`}
            placeholder="Informe o Nome Social"
            mt="25px"
            onChange={(e) =>
              setFieldValue("nomeSocial", forNames(e.target.value))
            }
            isDisabled={
              (values.nomeFicticio && values?.nomeFicticio.length > 0) ||
              values.nomeFicticio === true
            }
          />
        </Flex>
      </Flex>
      <Grid mt="15px" templateColumns="repeat(3, 1fr)" gap="25px" rowGap="20px">
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <Flex alignItems={errors.idGenero ? "center" : "end"} gap={2}>
            <CustomSelectWField
              fieldName="idGenero"
              label="Gênero*"
              placeholder="Selecione o Gênero"
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.id}
              isLoading={generos.isLoading}
              options={generos.options}
              onChange={(value) => {
                setFieldValue("idGenero", value);
              }}
              onFocus={generos.options.length === 0 ? handleGetGeneros : null}
            />

            {values.idGenero && isMobile && (
              <PopoverGenero
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                handleClick={handleClick}
                labelTextoGenero={
                  values?.idGenero?.label?.props?.children[1]?.props?.label
                }
              />
            )}
          </Flex>
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <VStack alignItems="flex-start">
            <CustomDatepickerWField
              fieldName="dataNascimento"
              label="Data de Nascimento*"
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
              onBeforeChange={async (newDate, oldDate) => {
                const tryParseDate = (date) => {
                  if (!date) {
                    return null;
                  }
                  if (typeof date === "string") {
                    if (date.length !== 10) {
                      return null;
                    }
                    const parsed = parse(date, "dd/MM/yyyy", new Date());
                    return isValid(parsed) ? parsed : null;
                  }
                  if (date instanceof Date) {
                    return isValid(date) ? date : null;
                  }
                  return null;
                };

                const parsedOldDate =
                  tryParseDate(oldDate) || tryParseDate(newDateRef.current);
                const parsedNewDate = tryParseDate(newDate);

                if (!parsedNewDate || !parsedOldDate) {
                  return true;
                }

                const today = new Date();
                const idadeNova = intervalToDuration({
                  start: parsedNewDate,
                  end: today,
                })?.years;
                const idadeAntiga = intervalToDuration({
                  start: parsedOldDate,
                  end: today,
                })?.years;

                if (idadeAntiga >= 16 && idadeNova < 16) {
                  const result = await Swal.fire({
                    title: "Atenção",
                    text: "Ao editar a data de nascimento, a aba Profissionalização e o campo CTPS serão excluídos. Esses campos só são habilitados para maiores de 16 anos. Deseja prosseguir?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#169499",
                    cancelButtonColor: "#169499",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                  });

                  return result.isConfirmed;
                }

                return true;
              }}
            />

            {dataMenor && values.dataNascimento && dataMovimentacao && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data de nascimento não pode ser superior a data do movimento
              </Text>
            )}
            {dataFutura && values.dataNascimento && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data informada não pode ser uma data futura!
              </Text>
            )}
            {!dataFutura &&
              !dataMenor &&
              !movimentacoesPendente &&
              dataMovimentacaoFlag?.dataMovimentacao &&
              houveExtincaoPoderFamiliar &&
              values.dataNascimento &&
              values.dataNascimento.length === 10 &&
              flag && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  {`Alteração não permitida. Data de nascimento incompatível com o
                  motivo de acolhimento ${dataMovimentacaoFlag?.tipoMotivoSituacao}`}
                </Text>
              )}

            {movimentacoesPendente &&
              values.dataNascimento &&
              menorIdade &&
              values?.dataNascimento?.length === 10 &&
              !dataFutura &&
              !dataMenor && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  Alteração não permitida. Existe uma movimentação de pendente
                  por maioridade cadastrada
                </Text>
              )}
            <Field name="dataNascimentoEstimada">
              {({ field, form }) => (
                <FormControl id="dataNascimentoEstimada" width="max-content">
                  <Checkbox
                    {...field}
                    isChecked={field.value}
                    name="dataNascimentoEstimada"
                    id="dataNascimentoEstimada"
                    whiteSpace="nowrap"
                  >
                    Data de Nascimento Estimada
                  </Checkbox>
                  <FormErrorMessage>
                    {form.errors.dataNascimentoEstimada}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </VStack>
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idRaca"
            label="Raça/Cor*"
            placeholder="Selecione a Raça/Cor"
            getOptionLabel={(option) => option.raca}
            getOptionValue={(option) => option.id}
            isLoading={racasCores.isLoading}
            options={racasCores.options}
            onChange={(value) => {
              setFieldValue("idRaca", value);
            }}
            onFocus={
              racasCores.options.length === 0 ? handleGetRacasCores : null
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="nacionalidade"
            label="Nacionalidade"
            placeholder="Selecione a Nacionalidade"
            getOptionLabel={(option) => option.nacionalidade}
            getOptionValue={(option) => option.id}
            isLoading={nacionalidades.isLoading}
            options={nacionalidades.options}
            onChange={(value) => {
              if (!!value) {
                if (value.nacionalidade !== "BRASIL") {
                  setFieldValue("idNaturalidade", "");
                }
              }
              setFieldValue("nacionalidade", value);
            }}
            onFocus={
              nacionalidades.options.length === 0
                ? handleGetNacionalidades
                : null
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="idNaturalidade"
            label="Naturalidade"
            placeholder="Informe a Naturalidade"
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            isLoading={estados.isLoading}
            options={estados.options}
            onChange={(value) => {
              setFieldValue("idNaturalidade", value);
            }}
            onFocus={estados.options.length === 0 ? handleGetEstados : null}
            isDisabled={
              !!values.nacionalidade
                ? values.nacionalidade.nacionalidade !== "BRASIL"
                : false
            }
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="tipoSanguineo"
            label="Tipo Sanguíneo"
            placeholder="Selecione o Tipo Sanguíneo"
            getOptionLabel={(option) => option.tipoSanguineo}
            getOptionValue={(option) => option.id}
            isLoading={tiposSanguineos.isLoading}
            options={tiposSanguineos.options}
            onChange={(value) => {
              setFieldValue("tipoSanguineo", value);
            }}
            onFocus={
              tiposSanguineos.options.length === 0
                ? handleGetTiposSanguineos
                : null
            }
          />
        </GridItem>
      </Grid>
    </Group>
  );
};
